import { deepCloneArray, deepCloneObject, func_serviceHandling, func_validation, isArrayEmpty, isArrayNotEmpty, isDateValid, isFunction, isNumberOrStringValid, isObject, isObjectEmpty, isObjectNotEmpty, isStringTrimNotEmpty } from 'functions';
import { useState, useRef, useEffect } from 'react';
import { useDispatch, connect } from 'react-redux';
import moment from "moment";
import useReporting from 'dataflow/billingPortal/actions/useReporting.actions';
import { useCustomSelector } from 'hooks';
import { resetSalesCommissionReportState } from 'dataflow/billingPortal/slices/reporting.slices';


export function useTableData({ setSelectedSalesPersonMonthly: setSelectedSalesPersonMonthly_props }) {
    let setSelectedSalesPersonMonthly = isFunction(setSelectedSalesPersonMonthly_props)? setSelectedSalesPersonMonthly_props: () => {};

	const dispatch = useDispatch();

	const [data, setData] = useState([{}, {}, {}, {}]);
	const [totalDataRow, setTotalDataRow] = useState({});
	const [startDate, setStartDate] = useState();
	const [salesPersonCode, setSalesPersonCode] = useState();
	const [isMounted, setIsMounted] = useState();

	useEffect(() => {
		if (!isMounted) setIsMounted(true);
	}, [isMounted]);

	const {
		invoiceCommissionList, isInvoiceCommissionLevel1,
		creditNoteCommissionList, isCreditNoteCommissionLevel1
	} = useCustomSelector("reporting");

	const {
		getInvoiceCommissionList, getCreditNoteCommissionList
	} = useReporting();

	useEffect(() => {
        // Reset redux store
        dispatch(resetSalesCommissionReportState());
		resetData();
    }, []);

	function resetData() {
		setData([{}, {}, {}, {}]); 
		setTotalDataRow({});
	}

	function getData(agent, date) {
		// both input filters required
		if (agent && date) {
			let filters = {
				agent,
				dtFrom: date,
				dtTo: moment(date).add(3, "month").format("YYYY/MM/DD")
			};

			setStartDate(date);

			getInvoiceCommissionList(null, null, null, { ...filters, agentType: "Salesperson", level1: true });
			getInvoiceCommissionList(null, null, null, { ...filters, agentType: "Salesperson", level1: false });
	
			getCreditNoteCommissionList(null, null, null, { ...filters, agentType: "Salesperson", level1: true });
			getCreditNoteCommissionList(null, null, null, { ...filters, agentType: "Salesperson", level1: false });
	
			// Reset
			resetData();
		}
	}

	useEffect(() => {
		if (isMounted && isDateValid(startDate)) {
			let totalsObj = {
				invoiceLevel1: {},
				invoiceLevel2: {},
				creditNoteLevel1: {},
				creditNoteLevel2: {}
			};
			if (isObjectNotEmpty(totalDataRow)) {
				totalsObj = deepCloneObject(totalDataRow);
			}

			let startMonth = moment(startDate).month() + 1;
	
			let newData = deepCloneArray(data);
			if (isArrayNotEmpty(invoiceCommissionList)) {
				newData[0]["SalesPersonCode"] = invoiceCommissionList[0]?.AgentCode;
				setSelectedSalesPersonMonthly(invoiceCommissionList[0]?.AgentCode);
	
				let propertyName = "invoiceLevel2";
				if (isInvoiceCommissionLevel1) {
					propertyName = "invoiceLevel1";
				}
				invoiceCommissionList.map((details, idx) => {
					if (isObject(newData?.[idx]) && isStringTrimNotEmpty(propertyName)) {
						let month = isNumberOrStringValid(details?.Month)? details?.Month: startDate;

						newData[month - startMonth][propertyName] = {
							Year: details?.Year,
							Month: details?.Month,
							TotalSales: details?.Total_Sales,
							TotalCommission: details?.Total_Commission,
							TotalSalesByAgent: details?.Total_Sales_By_Agent,
							TotalCommissionByAgent: details?.Total_Commission_By_Agent
						}
					}
	
					if (idx === 0 && isObject(totalsObj?.[propertyName])) {
						totalsObj[propertyName]["TotalSalesByAgent"] = details?.Total_Sales_By_Agent;
						totalsObj[propertyName]["TotalCommissionByAgent"] = details?.Total_Commission_By_Agent;
					}
				});
			}
	
			if (isArrayNotEmpty(creditNoteCommissionList)) {
				newData[0]["SalesPersonCode"] = creditNoteCommissionList[0]?.AgentCode;
				setSelectedSalesPersonMonthly(creditNoteCommissionList[0]?.AgentCode);
	
				let propertyName = "creditNoteLevel2";
				if (isCreditNoteCommissionLevel1) {
					propertyName = "creditNoteLevel1";
				}
	
				creditNoteCommissionList.map((details, idx) => {
					if (isObject(newData?.[idx]) && isStringTrimNotEmpty(propertyName)) {
						let month = isNumberOrStringValid(details?.Month)? details?.Month: startMonth;

						newData[month - startMonth][propertyName] = {
							Year: details?.Year,
							Month: details?.Month,
							TotalSales: details?.Total_Sales,
							TotalCommission: details?.Total_Commission,
							TotalSalesByAgent: details?.Total_Sales_By_Agent,
							TotalCommissionByAgent: details?.Total_Commission_By_Agent
						}
					}
	
					if (idx === 0 && isObject(totalsObj?.[propertyName])) {
						totalsObj[propertyName]["TotalSalesByAgent"] = details?.Total_Sales_By_Agent;
						totalsObj[propertyName]["TotalCommissionByAgent"] = details?.Total_Commission_By_Agent;
					}
				});
			}
	
			// Set the data for "total" row	
			newData[3] = {
				SalesPersonCode: "Total",
				invoiceLevel1: {
					TotalSales: totalsObj?.invoiceLevel1?.TotalSalesByAgent,
					TotalCommission: totalsObj?.invoiceLevel1?.TotalCommissionByAgent
				},
				invoiceLevel2: {
					TotalSales: totalsObj?.invoiceLevel2?.TotalSalesByAgent,
					TotalCommission: totalsObj?.invoiceLevel2?.TotalCommissionByAgent
				},
				creditNoteLevel1: {
					TotalSales: totalsObj?.creditNoteLevel1?.TotalSalesByAgent,
					TotalCommission:  totalsObj?.creditNoteLevel1?.TotalCommissionByAgent
				},
				creditNoteLevel2: {
					TotalSales: totalsObj?.creditNoteLevel2?.TotalSalesByAgent,
					TotalCommission:  totalsObj?.creditNoteLevel2?.TotalCommissionByAgent
				},
			};
	
			setTotalDataRow(totalsObj);
			setData(newData);
		}
	}, [
		isMounted,
		invoiceCommissionList, isInvoiceCommissionLevel1, 
		creditNoteCommissionList, isCreditNoteCommissionLevel1
	]);

    return {
        data, getData, startDate, salesPersonCode
    }
}